<template>
  <div class="player">
    <div class="player-inner">
      <video-player class="" ref="videoPlayer" style="width: 100%; height: 100%;" :options="playerOptions" @ready="onPlayerReadied" @playing="onPlayerPlaying($event)" v-if="loadPlayer"></video-player>
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: "video",
  props: ["load-player", "url", "autoplay"],
  data () {
    return {
      playerOptions: {
        loop: true,
        debug: false,
        preload: "none",
        overNative: true,
        autoplay: false,
        controls: true,
        techOrder: ['html5', 'flash'],
        sourceOrder: true,
        muted: false,
        aspectRatio: "16:9",
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
        sources: [{
          withCredentials: false,
          type: "application/x-mpegURL",
          src: this.url
        }],
        controlBar: {
          children: [
            'playToggle',
            'spacer',
            'muteToggle',
            'volumeControl',
            'fullscreenToggle',
          ],
        },
      }
    }
  },
  watch: {
    url (newVal) {
      if(newVal) this.playerOptions.sources[0].src = newVal;
    }
  },
  computed: {
    player () {
      if(!this.$refs.videoPlayer) return undefined;
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    onPlayerReadied(player) {
      player.volume(0.000001);
    },
    onPlayerPlaying(player) {
      this.$emit("input", {
        width: player.videoWidth(),
        height: player.videoHeight()
      })
    }
  }
}
</script>

<style scoped>
.player {
  padding-top: 56.25%;
  position: relative;
}
.player-inner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
<style>
  .vjs-spacer {
    flex: 1 1 auto;
  }
  .vjs-big-play-button {
    top: 50% !important;
    left: 50% !important;
    transform: translateX(-50%) translateY(-50%) !important;
    -webkit-transform: translateX(-50%) translateY(-50%) !important;
  }
</style>
